const postAddDocumentServices = {
  toastr: 'Document added',
  toastr1:'The document has been successfully added.'
};

export default postAddDocumentServices;
